import React, { useCallback } from 'react';

interface CustomTimeInputProps {
    selectedDate: Date | null;
    setSelectedDate: (date: Date) => void;
    selectedHour: number | undefined;
    setSelectedHour: (hour: number) => void;
    selectedMinute: number | undefined;
    setSelectedMinute: (minute: number) => void;
}

const TimeInput = (props: CustomTimeInputProps) => {
    const handleClick = useCallback((event: React.MouseEvent<HTMLDivElement>, value: number) => {
        event.preventDefault();
        event.stopPropagation();
        const parentId = event.currentTarget.parentElement?.id;
        const tempDate = props.selectedDate !== null ? new Date(props.selectedDate) : new Date();
        if (parentId === 'hour') {
            props.setSelectedHour(value);
            tempDate.setHours(value);
        } else if (parentId === 'minute') {
            props.setSelectedMinute(value);
            tempDate.setMinutes(value);
        }
        props.setSelectedDate(tempDate);
    }, [props.selectedDate]);

    return (
        <>
            <div id='hour' className='time-picker-list'>
                {Array.from({ length: 24 }, (_, i) => (
                    <div
                        id={`hour-${i}`}
                        onClick={(e) => handleClick(e, i)}
                        className={`${i === props.selectedHour ? 'time-selected' : ''} time-picker-tiem-list-item`}
                    >
                        {i.toString().padStart(2, '0')}
                    </div>
                ))}
            </div>
            <div id='minute' className='time-picker-list'>
                {Array.from({ length: 60 }, (_, i) => (
                    <div
                        id={`minute-${i}`}
                        onClick={(e) => handleClick(e, i)}
                        className={`${i === props.selectedMinute ? 'time-selected' : ''} time-picker-tiem-list-item`}
                    >
                        {i.toString().padStart(2, '0')}
                    </div>
                ))}
            </div>
        </>);
};

export default TimeInput;
